import { Divider, Stack, Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import Iconify from "minimals-template/components/Iconify"
import { If } from "lib/@components/switch"

export function TaskCompareScheduleDetails() {
    const { scheduleTitle, scheduleCode } = useBoundContext()
    return (
        <Stack>
            <Divider sx={{ py: 1 }} />
            <Stack direction="row" spacing={1} sx={{ alignItems: "center", mt: 1 }}>
                <Iconify icon={"pixelarticons:notes-multiple"} />
                <Typography variant="body2" data-cy="task-compare-schedule-title">
                    {scheduleTitle}
                </Typography>
            </Stack>
            <If value={!!scheduleCode}>
                <Typography
                    variant="body2"
                    sx={{ color: "text.secondary", ml: 3 }}
                    data-cy="task-compare-schedule-code"
                >
                    #{scheduleCode}
                </Typography>
            </If>
        </Stack>
    )
}
